import styled from 'styled-components';

// Header
const Header = styled.h1`
    display: flex;
    box-sizing: border-box;
    max-width: 100%;
    -webkit-box-align: center;
    align-items: center;
    min-width: 0px;
    min-height: 0px;
    flex-direction: row;
    flex: 0 0 auto;
    -webkit-box-pack: justify;
    justify-content: space-between;
`;

export default Header;
